import { create } from 'zustand';
import { PaginationState } from './type';
import { EGameIntroductionType } from '@/types/request';

type GameIntroFilter = PaginationState & {
  search?: string;
  type?: EGameIntroductionType;
};

type GameIntroState = {
  filter: GameIntroFilter;
  id?: number | null;
  openDetail: boolean;
};

type GameIntroAction = {
  setParams: (params: Partial<GameIntroFilter>) => void;
  setGameIntroId: (id: number) => void;
  onOpenDetail: (id?: number | null) => void;
  onCloseDetail: () => void;
};

export type GameIntroStore = GameIntroState & GameIntroAction;

export const useGameIntroStore = create<GameIntroStore>()((set, get) => ({
  filter: {
    search: '',
    page: 1,
    limit: 10,
  },
  openDetail: false,
  setParams: (params) => set({ filter: { ...get().filter, ...params } }),
  setGameIntroId: (id) => set({ id }),
  onOpenDetail: (id) => set({ id, openDetail: true }),
  onCloseDetail: () => set({ id: null, openDetail: false }),
}));
